import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

console.log("API Base URL:", process.env.REACT_APP_API_BASE_URL);

axiosInstance.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    // const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  // function (error) {
  //   return Promise.reject(error);
  // }
  function (error) {
    // HANDLE TOKEN EXPIRY HERE
    if (error.response.data?.detail === "invalid token.") {
      localStorage.removeItem("token");
      localStorage.clear();
      alert("Session expired. Please login again.");

      // redirect to login
      window.location.href = "/login";
    }

    return Promise.reject(error);
  },
);
